var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"d-flex flex-column"},[_c('span',{staticClass:"nv-quote nv-left-quote d-none d-sm-flex"},[_vm._v("“")]),_vm._t("default"),_c('span',{staticClass:"nv-quote nv-right-quote d-none d-sm-flex"},[_vm._v("”")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }